module.exports = __webpack_public_path__ + "static/media/lingshou-4.7dde274a.png";